export const UPLOAD_FILE = "File.UPLOAD_FILE";
export const UPLOAD_FILE_SUCCESS = "File.UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAILURE = "File.UPLOAD_FILE_FAILURE";

export const OPEN_MODAL = "File.OPEN_MODAL";
export const CLOSE_MODAL = "File.CLOSE_MODAL";
